export const key = () => (
  <path
    d="M20 2l-1 1m0 0l4 4-2 2-1-1-2 2-3-3m4-4l-4 4m-4.61 4.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777l.001-.001zm0 0L15 7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
